import React, { Component } from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";
import moment from "moment";

export default class FormService extends Component {
	constructor () {
		super();
		this.initialState = {
			salida: "",
			salida_fecha: "",
			salida_hora: "",
			regreso: "",
			regreso_fecha: "",
			regreso_hora: "",
			modelo: "",
			autobus: "",
			destino: "",
			folio: "",
			contratante: "",
			observaciones: "",
			fetching: false
		}
		this.state = this.initialState;
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleBusChange = this.handleBusChange.bind(this);
		this.handleSalidaFechaChange = this.handleSalidaFechaChange.bind(this);
		this.handleSalidaHoraChange = this.handleSalidaHoraChange.bind(this);
		this.handleRegresoFechaChange = this.handleRegresoFechaChange.bind(this);
		this.handleRegresoHoraChange = this.handleRegresoHoraChange.bind(this);
		this.handleDestinoChange = this.handleDestinoChange.bind(this);
		this.handleFolioChange = this.handleFolioChange.bind(this);
		this.handleContratanteChange = this.handleContratanteChange.bind(this);
		this.handleObservacionesChange = this.handleObservacionesChange.bind(this);
	}
	handleFormSubmit (e) {
		e.preventDefault();
		const {salida,regreso,destino, folio, contratante, observaciones} = this.state;
		const data = {
			salida,
			regreso,
			destino,
			observaciones,
			folio: parseInt(folio,10) || null,
			contractor_id: contratante || null
		};
		this.setState({fetching: true});
		api.post(`buses/${this.state.autobus}/services`,data)
		.then(()=>{
			swal("Servicio creado",`<b>${destino}</b><br/>${salida} &rarr; ${regreso}`,"success");
			this.setState(this.initialState);
		})
		.catch(error=>{
			if (error.response) {
				if (error.response.status === 406) {
					//http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
					const info = error.response.data.map(({salida,regreso,destino})=>{
						const scapedDestino = destino.replace(/[\"&<>]/g, function (a) {
							return { '"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;' }[a];
						});
						return `<li>${scapedDestino}:<br/>${salida} &rarr; ${regreso}</li>`
					}).reduce((info)=>info);
					swal("Conflictos",`<ul>${info}</ul>`,"info");
				} else {
					swal("Error",`Status: ${status}`,"error");
				}
			} else {
				swal("Error",error.message,"error");
			}
			console.error()
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleModelChange ({target: {value}}) {
		this.setState({modelo: value});
	}
	handleBusChange ({target: {value}}) {
		this.setState({autobus: value});
	}
	handleSalidaFechaChange ({target:{value}}) {
		this.setState({
			salida_fecha: value,
			salida: `${value} ${this.state.salida_hora}`
		});
	}
	handleSalidaHoraChange ({target:{value}}) {
		this.setState({
			salida_hora: value,
			salida: `${this.state.salida_fecha} ${value}`
		});
	}
	handleRegresoFechaChange ({target:{value}}) {
		this.setState({
			regreso_fecha: value,
			regreso: `${value} ${this.state.regreso_hora}`
		});
	}
	handleRegresoHoraChange ({target:{value}}) {
		this.setState({
			regreso_hora: value,
			regreso: `${this.state.regreso_fecha} ${value}`
		});
	}
	handleDestinoChange ({target: {value}}) {
		this.setState({destino: value});
	}
	handleFolioChange ({target: {value}}) {
		this.setState({folio: value});
	}
	handleContratanteChange ({target: {value}}) {
		this.setState({contratante: value});
	}
	handleObservacionesChange ({target: {value}}) {
		this.setState({observaciones: value});
	}


	render() {
		const contratantes = this.props.contratantes.map(({name,id},i)=><option key={i} value={id}>{name}</option>);
		const {data} = this.props;
		const models = data.map(({name,id},i)=><option key={i} value={id}>{name}</option>);
		let buses;
		try {
			buses = data.find(({id})=>id==this.state.modelo).buses.map(({id,name},i)=><option key={i} value={id}>{name}</option>);
		} catch (e) {
			//found nothing
		}
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Crear nuevo servicio</div>
				<div className="row">
					<label className="columns small-3">
						<em>Salida</em>
						<input type="date" value={this.state.salida_fecha} onChange={this.handleSalidaFechaChange} required/>
					</label>
					<label className="columns small-3">
						<em>Hora</em>
						<input type="time" value={this.state.salida_hora} onChange={this.handleSalidaHoraChange} required/>
					</label>
					<label className="columns small-3">
						<em>Regreso</em>
						<input type="date" value={this.state.regreso_fecha} min={this.state.salida_fecha} onChange={this.handleRegresoFechaChange} required/>
					</label>
					<label className="columns small-3">
						<em>Hora</em>
						<input type="time" value={this.state.regreso_hora} min={this.state.salida_fecha === this.state.regreso_fecha ? moment(this.state.salida_hora,"HH:mm:ss").add(1,"minute").format("HH:mm:ss") : ""} onChange={this.handleRegresoHoraChange} required/>
					</label>
					<label className="columns small-3">
						<em>Modelo</em>
						<select value={this.state.modelo} onChange={this.handleModelChange} required>
							<option disabled value=""> --- Selectiona --- </option>
							{models}
						</select>
					</label>
					<label className="columns small-3">
						<em>Autobus</em>
						<select disabled={!this.state.modelo} value={this.state.autobus} onChange={this.handleBusChange} required>
							<option disabled value=""> --- Selectiona --- </option>
							{buses}
						</select>
					</label>
					<label className="columns small-3">
						<em>Folio</em>
						<input type="number" value={this.state.folio} onChange={this.handleFolioChange}/>
					</label>
					<label className="columns small-3">
						<em>Contratante</em>
						<select value={this.state.contratante} onChange={this.handleContratanteChange}>
							<option value=""> --- Selectiona --- </option>
							{contratantes}
						</select>
					</label>
					<label className="columns small-12">
						<em>Observaciones</em>
						<textarea value={this.state.observaciones} onChange={this.handleObservacionesChange} rows="1" maxLength="100" style={{resize: "none"}}/>
					</label>
					<label className="columns small-6">
						<em>Destino</em>
						<input type="text" value={this.state.destino} onChange={this.handleDestinoChange} required/>
					</label>
					<label className="columns small-6">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching}>Guardar</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_service.js
 **/